import React from 'react';
import {Text} from '@priority-software/priority-style-react';
import {Value} from '../Value';
import {Templates} from '../../constants';
import styles from './styles.module.scss';

interface Props {
    data: any[];
    entityId: string | null;
}

export const MoreInfoColumn = ({data, entityId}: Props) => {
    return (
        <div className={styles.component}>
            {data.map((field, idx) => {
                return (
                    <div key={idx}>
                        {field.Type !== 'File' && (
                            <Text
                                tag="div"
                                skin="caption-2"
                                textColor="secondary-500"
                                componentClasses={styles.itemTitle}
                            >
                                {field.ColumnTitle}
                            </Text>
                        )}
                        <Text tag="div" skin="paragraph-2" textColor="primary-700">
                            <Value {...field} entityId={entityId} template={Templates.column} />
                        </Text>
                    </div>
                );
            })}
        </div>
    );
};
